/**
 * Copyright 2020 ExpediaGroup. All rights reserved.
 * EXPEDIA PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

const BrandName = Object.freeze({
  expedia: 'Expedia',
  hotels: 'Hotel',
  hoteles: 'Hotel',
  hoteis: 'Hotel',
});

export default BrandName;
